import moment from 'moment'

/**
 * Standardized date display formats across the site.
 * Granularity -> Format -> Example
 * Daily: MMM DD, YYYY (Feb 02, 2026)
 * Weekly: Week X, YYYY (Week 2, 2026)
 * Monthly: MMM YYYY (Feb 2026)
 * Quarterly: QX YYYY (Q1 2026)
 * Yearly: YYYY (2026)
 */

export function formatDateByGranularity(dateValue, granularity) {
  if (!dateValue) return ''
  const str = String(dateValue).trim()
  // 纯年份（dateType=4）：API 返回数字 2026，moment(2026) 会当毫秒时间戳解析成 1970，直接原样显示
  if (granularity === 'yearly' || granularity === '4') {
    if (/^\d{4}$/.test(str)) return str
  }
  const m = moment(dateValue)
  if (!m.isValid()) return String(dateValue)
  switch (granularity) {
    case 'daily':
    case '0':
      return m.format('MMM DD, YYYY')
    case 'weekly':
    case '1': {
      const str = String(dateValue)
      if (str.length <= 7 && /^\d{4}-?\d{1,2}$/.test(str)) {
        const [y, w] = str.split('-')
        const weekNum = parseInt(w, 10) || m.isoWeek()
        return `Week ${weekNum}, ${y || m.format('YYYY')}`
      }
      const weekNum = m.isoWeek()
      const year = m.format('YYYY')
      return `Week ${weekNum}, ${year}`
    }
    case 'monthly':
    case '2':
      return m.format('MMM YYYY')
    case 'quarterly':
    case '3': {
      const str = String(dateValue)
      const qMatch = str.match(/^(\d{4})-?Q?(\d)$/i)
      if (qMatch) {
        const year = qMatch[1]
        let q = parseInt(qMatch[2], 10)
        if (q < 1 || q > 4) return str // avoid Q0 or invalid, return as-is
        return `Q${q} ${year}`
      }
      return `Q${m.quarter()} ${m.format('YYYY')}`
    }
    case 'yearly':
    case '4':
      return m.format('YYYY')
    default:
      return m.format('MMM DD, YYYY')
  }
}

/** Format YYYY-MM-DD to MMM DD, YYYY */
export function formatDaily(dateStr) {
  return dateStr ? moment(dateStr).format('MMM DD, YYYY') : ''
}

/** Format YYYY-WW or date to Week X, YYYY */
export function formatWeekly(dateStr) {
  if (!dateStr) return ''
  const m = moment(dateStr)
  if (typeof dateStr === 'string' && dateStr.length <= 7 && dateStr.indexOf('W') !== -1) {
    const [y, w] = dateStr.split('-')
    const weekNum = parseInt(w.replace('W', ''), 10) || m.isoWeek()
    return `Week ${weekNum}, ${y || m.format('YYYY')}`
  }
  return `Week ${m.isoWeek()}, ${m.format('YYYY')}`
}

/** Format YYYY-MM to MMM YYYY */
export function formatMonthly(dateStr) {
  return dateStr ? moment(dateStr).format('MMM YYYY') : ''
}

/** Format to QX YYYY */
export function formatQuarterly(dateStr) {
  if (!dateStr) return ''
  const m = moment(dateStr)
  return `Q${m.quarter()} ${m.format('YYYY')}`
}

/** Format to YYYY */
export function formatYearly(dateStr) {
  return dateStr ? moment(dateStr).format('YYYY') : ''
}
